import chaletApi from "api/chaletApi";
import { ChaletApiResponse } from "types/ChaletApiResponse";
import { DriverOffer } from "types/DriverOffer";
import { Ride } from "types/Ride";
import { TravelOffer } from "types/TravelOffer";
type Paginated<T> = {
  data: T[];
  meta: { page: number; totalPages: number };
};

const TravelOfferService = chaletApi.injectEndpoints({
  endpoints: (builder) => ({
    getTravelOffersHistory: builder.query<Paginated<TravelOffer>, { sectorId: number; page: number; limit?: number }>({
      query: ({ sectorId, page, limit = 20 }) => ({
        method: "GET",
        url: "/travel-offers/all",
        params: { sectorId, page, limit },
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      merge: (currentCache, newData) => {
        currentCache.data.push(...newData.data);
        currentCache.meta = newData.meta;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page;
      },
    }),
    getTravelOffersActiveBySector: builder.query<TravelOffer[], { sectorId: number }>({
      query: (params) => ({
        method: "GET",
        url: `/travel-offers/all/active/by/sector`,
        params: params,
      }),
      transformResponse: (response: ChaletApiResponse<TravelOffer[]>) => response.data,
    }),
    getDriverOffers: builder.query<DriverOffer[], number>({
      query: (sectorId) => ({
        method: "GET",
        url: `/driver-offers/${sectorId}/all`,
      }),
      transformResponse: (response: ChaletApiResponse<DriverOffer[]>) => response.data,
    }),
    getActiveRides: builder.query<Ride[], number>({
      query: (sectorId) => ({
        method: "GET",
        url: `/rides/${sectorId}/all/active`,
      }),
      transformResponse: (response: ChaletApiResponse<Ride[]>) => response.data,
    }),
    getTravelOfferDriverOffers: builder.query<DriverOffer[], number>({
      query: (travelOfferId) => ({
        method: "GET",
        url: `/driver-offers/${travelOfferId}/by-travel-offer`,
      }),
      transformResponse: (response: ChaletApiResponse<DriverOffer[]>) => response.data,
    }),
    cancelRide: builder.mutation<boolean, number>({
      query: (rideId) => ({
        method: "PUT",
        url: `/rides/cancel/${rideId}`,
      }),
      transformResponse: (response: ChaletApiResponse<boolean>) => response.data,
    }),
  }),
  overrideExisting: true,
});

export default TravelOfferService;
